export enum TourType {
  DESTINATION = 'destination',
  TOUR = 'tour'
}
